import React from 'react'
import SearchResultContainer from '../../../Components/Apps/SearchResult'

export default function SearchResult() {
  return (
    <div className='page-body'>
        <SearchResultContainer/>
    </div>
  )
}
